import React, { Component } from 'react';
import { find, propEq, isNil, isEmpty, range, pluck } from 'ramda';
import { Helmet } from 'react-helmet';
import { MdUndo } from 'react-icons/md';
import { IoIosQrScanner } from 'react-icons/io';

import AdministrationPage from '../containers/AdministrationPage';
import BoardgameAdminItem from './BoardgameAdminItem';
import ScanQrModal from '../containers/ScanQrModal';

class AdminBoardgamesListNightPage extends Component {
  constructor(props) {
    super(props);

    this.onChangeBoardgamesSorting = this.onChangeBoardgamesSorting.bind(this);
    this.onChangeQuery = this.onChangeQuery.bind(this);
    this.onChangeNumberOfPlayers = this.onChangeNumberOfPlayers.bind(this);
    this.onGetBackAllBoardgamesClicked = this.onGetBackAllBoardgamesClicked.bind(this);
    this.onClearQueryClick = this.onClearQueryClick.bind(this);
    this.onScanClick = this.onScanClick.bind(this);
    this.onScanQrModalClose = this.onScanQrModalClose.bind(this);

    this.state = {
      orderBy: 'title',
      query: '',
      numberOfPlayers: '',
      maxNumberOfPlayers: 10,
      scanQrModalOpen: false,
    };

    this.queryRef = React.createRef();
  }

  componentDidMount() {
    this.props.getVisibleBoardgames(this.state.orderBy);
    this.props.getCategories();
  }

  componentWillUnmount() {
    this.props.unsubscribeToVisibleBoardgames();
  }

  onChangeBoardgamesSorting(event) {
    event.preventDefault();

    this.setState({ orderBy: event.target.value });
    this.props.getVisibleBoardgames(event.target.value);
  }

  onChangeQuery(event) {
    event.preventDefault();
    event.persist();
    this.setState({ query: event.target.value || '' });
  }

  onClearQueryClick() {
    this.setState({ query: '' });
    if (this.queryRef) {
      this.queryRef.current.focus();
    }
  }

  onChangeNumberOfPlayers(event) {
    event.preventDefault();
    event.persist();

    const value = event.target.value;

    const numberOfPlayers = !isEmpty(value)
      ? parseInt(value, 10)
      : '';

    this.setState({ numberOfPlayers });
  }

  onScanClick() {
    this.setState({ scanQrModalOpen: true });
  }

  onScanQrModalClose() {
    this.setState({ scanQrModalOpen: false });
  }

  onGetBackAllBoardgamesClicked(event) {
    event.preventDefault();

    if (window.confirm('Sei sicuro di voler proseguire?')) {
      const ids = pluck(
        'id',
        this.props.boardgamesWithReservation.filter(bg => bg.reservedCopies && bg.reservedCopies > 0)
      );

      this.props.getBackAllBoardgames(ids);
    }
  }

  getCategoriesForBoardgame(bg) {
    return (bg.categories || [])
      .map(id => find(propEq('id', id), this.props.categories))
      .filter(category => !isNil(category));
  }

  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Boardgame Night - Amministrazione - Smart Gaming</title>
        </Helmet>
        <AdministrationPage>
          <div className="flex justify-center flex-row md:flex-row mb-8 md:w-2/3 w-full mx-auto">
            <div className="relative w-3/5 md:mt-0 pr-1 md:w-full md:pr-0">
              <div className="block relative">
                <input
                  className="appearance-none border border-gray-400 rounded-full w-full py-2 px-5 text-gray-700 leading-tight focus:outline-none focus:shadow"
                  type="text"
                  placeholder="Cerca"
                  value={this.state.query}
                  onChange={this.onChangeQuery} ref={this.queryRef} />
                <button type="button" onClick={this.onClearQueryClick} className="absolute inset-y-0 right-0 flex items-center px-4 cursor-pointer text-gray-700">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                    <path fill="#cbd5e0" d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/>
                  </svg>
                </button>
              </div>
            </div>
            <div className="relative w-2/5 pl-1 md:hidden">
              <button
                type="button"
                className="bg-gray-600 text-white font-bold py-2 px-6 rounded-full flex justify-center items-center w-full"
                onClick={this.onScanClick}>
                <IoIosQrScanner size="1rem" className="mr-2" />
                <span>Scan</span>
              </button>
            </div>
          </div>
          <div className="flex justify-center flex-row mb-10 md:w-2/3 w-full mx-auto">
            <div className="md:inline-block relative md:w-64 w-1/2 md:pr-2 mr-2">
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="order_by">
                Ordina per
              </label>
              <div className="block relative">
                <select
                  id="order_by"
                  value={this.state.orderBy}
                  onChange={this.onChangeBoardgamesSorting}
                  className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-5 py-2 pr-8 rounded-full leading-tight focus:outline-none focus:shadow">
                  <option value="title">Nome</option>
                  <option value="playsCount">Popolarità</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-darker">
                  <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>
            <div className="md:inline-block relative md:w-64 w-1/2 md:pl-2 ml-2">
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="players_num">Numero di giocatori</label>
              <div className="block relative">
                <select
                  id="players_num"
                  className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-5 py-2 pr-8 rounded-full leading-tight focus:outline-none focus:shadow"
                  value={this.props.numberOfPlayers}
                  onChange={this.onChangeNumberOfPlayers}>
                  <option value="">Qualunque</option>
                  {
                    range(2, this.props.maxNumberOfPlayers + 1)
                      .map(numberOfPlayers => (
                        <option key={numberOfPlayers} value={numberOfPlayers}>{numberOfPlayers}</option>
                      ))
                  }
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-darker">
                  <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>
          </div>
          
          <div className="flex justify-center flex-col md:flex-row mb-10 md:w-2/3 w-full mx-auto">
            <button
              type="button"
              className={`bg-gray-600 text-white font-bold py-2 px-6 rounded-full flex justify-center items-center ${ !this.props.isGetBackAllBoardgamesButtonEnabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-white hover:text-gray-600 cursor-pointer' }`}
              onClick={this.onGetBackAllBoardgamesClicked}
              disabled={!this.props.isGetBackAllBoardgamesButtonEnabled}>
              <MdUndo size="1.2em" className="mr-2" />
              <span>Restituisci tutto</span>
            </button>
          </div>
          {
            this.props.boardgamesWithReservation && this.props.boardgamesWithReservation.length > 0 &&
              <h1 className="block text-left uppercase text-gray-700 text-sm font-bold mb-3">Attualmente in uso</h1>
          }
          <div className="flex flex-wrap justify-center">
            {
              this.props.boardgamesWithReservation
                .filter(bg => bg.title.toLocaleLowerCase().includes(this.state.query.trim().toLocaleLowerCase()))
                .filter(bg => {
                  return isEmpty(this.state.numberOfPlayers) || (this.state.numberOfPlayers >= bg.minPlayers && this.state.numberOfPlayers <= (bg.maxPlayers || bg.minPlayers));
                })
                .map(bg => (
                  <BoardgameAdminItem
                    key={bg.id}
                    id={bg.id}
                    title={bg.title}
                    image={bg.image}
                    description={bg.description}
                    minPlayTime={bg.minPlayTime}
                    maxPlayTime={bg.maxPlayTime}
                    minPlayers={bg.minPlayers}
                    maxPlayers={bg.maxPlayers}
                    showActions={this.props.isAuthenticated}
                    availableCopies={bg.availableCopies}
                    reservedCopies={bg.reservedCopies || 0}
                    onReserveBoardgame={this.props.reserveBoardgame}
                    onGetBackBoardgame={this.props.getBackBoardgame}
                    categories={bg.categories} />
                ))
            }
          </div>
          {
            this.props.boardgamesWithReservation && this.props.boardgamesWithReservation.length > 0
              && <h1 className="block text-left uppercase text-gray-700 text-sm font-bold mb-3">Disponibili</h1>
          }
          <div className="flex flex-wrap justify-center">
            {
              this.props.boardgames
                .filter(bg => bg.title.toLocaleLowerCase().includes(this.state.query.trim().toLocaleLowerCase()))
                .filter(bg => {
                  return isEmpty(this.state.numberOfPlayers) || (this.state.numberOfPlayers >= bg.minPlayers && this.state.numberOfPlayers <= (bg.maxPlayers || bg.minPlayers));
                })
                .map(bg => (
                  <BoardgameAdminItem
                    key={bg.id}
                    id={bg.id}
                    title={bg.title}
                    image={bg.image}
                    description={bg.description}
                    minPlayTime={bg.minPlayTime}
                    maxPlayTime={bg.maxPlayTime}
                    minPlayers={bg.minPlayers}
                    maxPlayers={bg.maxPlayers}
                    showActions={this.props.isAuthenticated}
                    availableCopies={bg.availableCopies}
                    reservedCopies={bg.reservedCopies || 0}
                    onReserveBoardgame={this.props.reserveBoardgame}
                    onGetBackBoardgame={this.props.getBackBoardgame}
                    categories={bg.categories} />
                ))
            }
          </div>
        </AdministrationPage>
        <ScanQrModal isOpen={this.state.scanQrModalOpen} onClose={this.onScanQrModalClose} />
      </React.Fragment>
    );
  }
}

export default AdminBoardgamesListNightPage;